import * as Yup from "yup";

export function initialValues(item) {
  return {
    title: item?.title || "",
    description: item?.description || "",
    sign: item?.sign || "Negativo",
    status: item?.status || "Real (ya ocurre)",
    scale: item?.scale || null,
    scope: item?.scope || null,
    irremediability: item?.irremediability || null,
    rawProbability: item?.rawProbability || null,
    controls: item?.controls || "",
    action: item?.action || "",
  };
}

export function validationSchema(t) {
  return Yup.object({
    title: Yup.string().required(t("required_field")),
    sign: Yup.string().required(t("required_field")),
    status: Yup.string().required(t("required_field")),
    scale: Yup.number().min(1).max(5).required(t("required_field")),
    scope: Yup.number().min(1).max(5).required(t("required_field")),
    irremediability: Yup.number()
      .min(1)
      .max(5)
      .nullable()
      .test("required-if-negative", t("required_field"), function (value) {
        return this.parent.sign !== "Negativo" || (value !== null && value !== undefined);
      }),
    rawProbability: Yup.number()
      .min(1)
      .max(5)
      .nullable()
      .test("required-if-potential", t("required_field"), function (value) {
        return this.parent.status !== "Potencial (podría ocurrir)" || (value !== null && value !== undefined);
      }),
  });
}
